/* eslint-disable no-shadow */
/* eslint-disable no-nested-ternary */
// const VERSION = "v1";

enum SERVER_URL {
  DEV = "https://ascimrtdev01.azurewebsites.net",
  SIT = "https://mrta-sit.azurewebsites.net",
  UAT = "https://creditlifeconnectuat.ageasfederal.com",
  PROD = "https://creditlifeconnect.ageasfederal.com",
  LOCAL = "http://localhost:3000",
  UAT2 = "https://creditlifeconnectuat2.ageasfederal.com"
}

const mapper: Record<string, any> = {
  "aflimrtadevfe2.z29.web.core.windows.net": SERVER_URL.DEV,
  "aflimrtafesit.z29.web.core.windows.net": SERVER_URL.SIT,
  "creditlifeconnectuat.ageasfederal.com": SERVER_URL.UAT,
  "creditlifeconnect.ageasfederal.com": SERVER_URL.PROD,
  "creditlifeconnectuat2.ageasfederal.com": SERVER_URL.UAT2
};
export const serverUrl = () => mapper[window?.location?.host] || SERVER_URL.LOCAL;
const API_URLS = {
  baseURL: `${serverUrl()}/api/v1`,
  login: "/auth/login",
  logout: "/auth/logout",
  leadUrl: "/quote/lead-details/",
  dashboard: "/quote/lead-list",
  masters: {
    pincode: "/masters/pincode",
    subOccupation: "/masters/subOccupation",
    country: "/masters/country",
    insuranceCompany: "/masters/insurance-company",
    policyStatus: "/masters/policy-status",
    rule_engine: "/masters/rule-engine",
    allProduct: "/masters/getAllProducts",
    channel: "/masters/channel",
    partner: "/masters/partners",
    allPartners: "/masters/all-partners",
    policyNumber: "masters/master-policy-holder"
  },
  salutation: "/masters/salutation",
  gender: "/masters/gender",
  occupation: "/masters/occupation",
  relationship: "/masters/relationship",
  education: "/masters/education",
  marital_status: "/masters/maritalStatus",
  sub_occupation: "/masters/subOccupation",
  sendReviewLink: "/link/send-review-link",
  customerDeclaration: "/quote/customer-declaration",
  sendOtp: "/link/verify-review-link",
  actionBucket: "/quote/update-bucket",
  sendLoginOtp: "/otp/send-login-otp",
  resendLoginOtp: "/otp/resend-login-otp",
  validateLoginOtp: "/otp/validate-login-otp",
  verifyOtp: "/link/verify-otp-for-review",
  sendPaymentLink: "/quote/send-payment-link",
  resendOTP: "/otp/resend-otp",
  setMember: "/quote/members",
  generateMef: "/mef/generate-mef",
  uploadSignedPdf: "/mef/upload-signed-mef",
  downloadDocument: "/mef/download-doc",
  setNomineeDetails: "/quote/nominee",
  deleteNomineeDetails: "/quote/delete-nominee",
  getReviewDetails: "/quote/review-details/",
  recalculatePremium: "/quote/recalculate-premium/",
  verifyPaymentLink: "/quote/verify-payment-link",
  documentUpload: "/mef/upload-doc",
  getUserList: "/irm-supervisor/irms-for-supervisor",
  caseReassign: "/irm-supervisor/reassign-case",
  initiatePayment: "/payment/initiate",
  paymentStatus: "/payment/status",
  triggerWorkflow: "/common/trigger-workflow",
  uploadPAF: "/quote/upload-paf",
  samlLogin: "/auth/login/saml",
  samlGetUser: "/users/who-am-i",
  setProportionate: "/quote/proportionate",
  createLead: "/quote/create",
  setAssignment: "/assignment/save",
  getMefJourneySchema: "/mef/validations",
  deleteAssignment: "/assignment/delete",
  uploadMultipleFiles: "/common/upload-multiple-files"
};

export default API_URLS;
